module.exports = __webpack_public_path__ + "static/slider-modal-4f2ff4f4adf38b5edaa0ba6a43db82db.jpg";